<template>
    <v-autocomplete
        v-model="network"
        :items="allowedNetworks"
        hide-selected
        label="Skill Networks"
        placeholder="Search by name of skills network..."
        prepend-icon="mdi-briefcase"
        clearable
        auto-select-first
        color="secondary"
    >
    </v-autocomplete>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'

const props = defineProps({
    initialNetwork: { type: String },
})
const emit = defineEmits(['changeNetwork'])

const store = useStore()

const selectedNetwork = ref(null)
const allowedNetworks = ref([])

const skillsNetworks = computed(() => store.state.skillsNetworks)
const user = computed(() => store.state.user)

const network = computed({
    get() {
        return selectedNetwork.value
    },
    set(value) {
        selectedNetwork.value = value
        emit('changeNetwork', value)
    },
})

onMounted(() => {
    if (props.initialNetwork) selectedNetwork.value = props.initialNetwork
    findAllowedNetworks()
})

function findAllowedNetworks() {
    const permissions = skillsNetworks.value
    const creator = user.value.displayName
    let allowed = []
    for (var key in permissions) {
        const people = permissions[key]
        if (people.find((person) => person === creator)) allowed.push(key)
    }
    allowedNetworks.value = allowed
}
</script>
